export default __webpack_public_path__ + "static/media/platform.046e58bf.png";